(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1472],{

/***/ 58577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
}), 'Business'));

/***/ }),

/***/ 7354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
}), 'Cloud'));

/***/ }),

/***/ 62111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
}), 'Public'));

/***/ }),

/***/ 72304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
}), 'Security'));

/***/ }),

/***/ 6597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var TimelineContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (TimelineContext);

/***/ }),

/***/ 5056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @ignore - internal component.
 */

var TimelineItemContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (TimelineItemContext);

/***/ }),

/***/ 43956:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobrenos",
      function () {
        return __webpack_require__(83350);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57180);








var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles);
function Loading(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            children: "Carregando...."
        })
    });
}


/***/ }),

/***/ 83350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AboutUS; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./components/Functions/Loading.js
var Loading = __webpack_require__(24552);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Timeline/TimelineContext.js
var TimelineContext = __webpack_require__(6597);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/TimelineItem/TimelineItemContext.js
var TimelineItemContext = __webpack_require__(5056);
;// CONCATENATED MODULE: ./node_modules/@material-ui/lab/esm/TimelineOppositeContent/TimelineOppositeContent.js









var styles = function styles() {
  return {
    /* Styles applied to the root element. */
    root: {
      padding: '6px 16px',
      marginRight: 'auto',
      textAlign: 'right',
      flex: 1
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'left'
    }
  };
};
var TimelineOppositeContent = /*#__PURE__*/react.forwardRef(function TimelineOppositeContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className"]);

  var _React$useContext = react.useContext(TimelineContext/* default */.Z),
      _React$useContext$ali = _React$useContext.align,
      align = _React$useContext$ali === void 0 ? 'left' : _React$useContext$ali;

  var _React$useContext2 = react.useContext(TimelineItemContext/* default */.Z),
      _React$useContext2$cl = _React$useContext2.classes,
      contextClasses = _React$useContext2$cl === void 0 ? {} : _React$useContext2$cl;

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, contextClasses.oppositeContent, classes["align".concat((0,capitalize/* default */.Z)(align))], className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
TimelineOppositeContent.muiName = 'TimelineOppositeContent';
/* harmony default export */ var TimelineOppositeContent_TimelineOppositeContent = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiTimelineOppositeContent'
})(TimelineOppositeContent));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Business.js
var Business = __webpack_require__(58577);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/BusinessCenter.js


/* harmony default export */ var BusinessCenter = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
}), 'BusinessCenter'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/HomeWork.js


/* harmony default export */ var HomeWork = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("path", {
  d: "M8.17 5.7L1 10.48V21h5v-8h4v8h5V10.25z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
})), 'HomeWork'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Cloud.js
var Cloud = __webpack_require__(7354);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Public.js
var Public = __webpack_require__(62111);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Security.js
var Security = __webpack_require__(72304);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/MoreVert.js


/* harmony default export */ var MoreVert = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(96230);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(18334);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(20907);
// EXTERNAL MODULE: ./styles/jss/bbhost/pages/landingPage.js
var landingPage = __webpack_require__(538);
// EXTERNAL MODULE: ./styles/jss/bbhost/pages/landingPageSections/teamStyle.js
var teamStyle = __webpack_require__(57180);
// EXTERNAL MODULE: ./pages-sections/HeaderSection.js + 3 modules
var HeaderSection = __webpack_require__(75994);
;// CONCATENATED MODULE: ./pages/sobrenos.js





// nodejs library that concatenates classes


// @material-ui/core components


// @material-ui/icons
var Timeline = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4328).then(__webpack_require__.bind(__webpack_require__, 4328));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4328)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
});
var TimelineItem = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 237).then(__webpack_require__.bind(__webpack_require__, 90237));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90237)
            ];
        }
    }
});
var TimelineSeparator = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 820).then(__webpack_require__.bind(__webpack_require__, 50820));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50820)
            ];
        }
    }
});
var TimelineConnector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5484).then(__webpack_require__.bind(__webpack_require__, 95484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95484)
            ];
        }
    }
});
var TimelineContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3635).then(__webpack_require__.bind(__webpack_require__, 83635));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83635)
            ];
        }
    }
});
var TimelineDot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8682).then(__webpack_require__.bind(__webpack_require__, 8682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8682)
            ];
        }
    }
});

var Typography = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 400).then(__webpack_require__.bind(__webpack_require__, 80400));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80400)
            ];
        }
    }
});
var Paper = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7613).then(__webpack_require__.bind(__webpack_require__, 7613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7613)
            ];
        }
    }
});


var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(5121), __webpack_require__.e(1788), __webpack_require__.e(7298)]).then(__webpack_require__.bind(__webpack_require__, 37298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37298)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
});


var sobrenos_styles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, landingPage/* default */.Z, teamStyle/* default */.Z), {
    textTypo: {
        fontSize: "0.875rem",
        "@media (min-width: 1200px)": {
            fontSize: "1rem"
        }
    }
});
// Sections for this page

var GridContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    }
});
var useStyles = (0,makeStyles/* default */.Z)(sobrenos_styles);
var SEO = {
    title: "BB Host",
    description: "BB Host Sobre N\xf3s",
    url: "https://www.bbhost.com.br/sobrenos",
    type: "website",
    languageAlternates: [
        {
            hrefLang: "en",
            href: "https://www.bbhost.com.br/en/sobrenos"
        },
        {
            hrefLang: "es",
            href: "https://www.bbhost.com.br/es/sobrenos"
        }
    ]
};
var __N_SSG = true;
function AboutUS(props) {
    var classes = useStyles();
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection/* default */.Z, {
                name: "about_us",
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(classes.main, classes.mainRaised),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridContainer, {
                            justifyContent: "center",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline, {
                                align: "alternate",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2013"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        color: "primary",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Business/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: "Fundada em 28 de setembro de 2013, a BB Host surgiu como uma op\xe7\xe3o de bom custo e \xf3timo atendimento no fornecimento do servi\xe7o de TeamSpeak, tendo como servi\xe7o secund\xe1rio servidores VPS."
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2015"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessCenter, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "2%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: "\xc0 medida que fomos ganhando espa\xe7o no mercado de TeamSpeak e chegando a ser uma das principais empresas no mercado do ramo, come\xe7amos a enfrentar problemas onde nenhuma solu\xe7\xe3o dispon\xedvel no momento em nosso pa\xeds nos atendia, devido ao grande fluxo de DDoS e problemas que ocorriam."
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2017"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeWork, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: [
                                                            "Tentamos utilizar todas as empresas no ramo de datacenter do Brasil, identificando como era o meio de atendimento e qualidade de todas, mas nenhuma supria a nossa necessidade ou agradava no modo de trabalhar.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "Buscando sempre um servi\xe7o de qualidade e atendimento excepcional, acabamos por n\xe3o encontrar op\xe7\xf5es.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "Ao ver a empresa sofrendo pela falta de empresas oferecendo servi\xe7o na qualidade que desej\xe1vamos, come\xe7amos a montar nosso pr\xf3prio datacenter, procurando o que havia de melhor em termos de estrutura e rede."
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2018"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        variant: "outlined",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cloud/* default */.Z, {
                                                            style: {
                                                                color: blue/* default.300 */.Z[300]
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: [
                                                            "Iniciamos ent\xe3o nossa estrutura com mitiga\xe7\xe3o pr\xf3pria, tendo um resultado promissor inicialmente, mas encontradas dificuldades que diversas empresas do ramo sofrem.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "Sempre buscando melhorias e otimiza\xe7\xf5es nas nossas solu\xe7\xf5es, este era o in\xedcio de uma longa caminhada, a fim de uma solu\xe7\xe3o DDoS completa.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2020"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        variant: "outlined",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Public/* default */.Z, {
                                                            style: {
                                                                color: green/* default.500 */.Z[500]
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: [
                                                            "Com uma conectividade exemplar, com os principais pops brasileiros, mitiga\xe7\xe3o incompar\xe1vel, utilizando diversos n\xedveis de mitiga\xe7\xf5es, conseguimos oferecer a qualidade de servi\xe7o que sempre estivemos buscando e temos orgulho de fornecer.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "Vamos sempre evoluir e melhorar onde for poss\xedvel e agradecemos todos os clientes que confiaram em n\xf3s durante esta jornada, agradecemos tamb\xe9m, a todos os futuros clientes que nos d\xe3o um voto de confian\xe7a para fornecer o que h\xe1 de melhor no mercado brasileiro!"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2021"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        variant: "outlined",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Security/* default */.Z, {
                                                            style: {
                                                                color: red/* default.500 */.Z[500]
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: [
                                                            "Expandimos ainda mais nossa solu\xe7\xe3o Anti-DDoS, com o DDoS Pro.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2022"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        variant: "outlined",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert, {
                                                            style: {
                                                                color: blue/* default.500 */.Z[500]
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper, {
                                                    elevation: 8,
                                                    className: classes.paper,
                                                    style: {
                                                        padding: "4%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography, {
                                                        align: "center",
                                                        className: classes.textTypo,
                                                        children: [
                                                            "Buscando sempre reduzir a lat\xeancia e melhor a expericia dos usuarios, aumentamos nossa capilaridade e seguran\xe7a.",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent_TimelineOppositeContent, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                                    variant: "body2",
                                                    color: "textSecondary",
                                                    children: "2023"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot, {
                                                        variant: "outlined",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert, {
                                                            style: {
                                                                color: blue/* default.500 */.Z[500]
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContent, {})
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);
/* harmony import */ var _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89395);




var teamStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    section: {
        padding: "20px 0",
        textAlign: "center"
    },
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    })
}, _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    itemGrid: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    cardTitle: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .cardTitle */ .X5,
    smallTitle: {
        color: "#6c757d"
    },
    description: {
        color: "#999"
    },
    justifyCenter: {
        justifyContent: "center !important"
    },
    socials: {
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
        color: "#999"
    },
    margin5: {
        margin: "5px"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (teamStyle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4888,8653,9774,2888,179], function() { return __webpack_exec__(43956); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);